
import Button from '../base/Button';

export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.6)), url('https://public.readdy.ai/ai/img_res/ffb37a08f72be92c2ca21a601deef6cf.jpg')`
        }}
      />

      <div className="container mx-auto px-4 z-10 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <p className="text-blue-300 font-semibold text-lg mb-4 tracking-wide uppercase">
            Strength Through Integrity
          </p>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Elevate Your Roof and Solar System with{' '}
            <span className="text-blue-300">California's Professionals</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto">
            Don't compromise your roof installation or repair. Choose a reliable solution. 
            Choose Shadowfax Roofing and Solar.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 shadow-lg transition-all duration-300 hover:scale-105"
            >
              CALL US AT (408) 628-0065
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={scrollToContact}
              className="border-2 border-white hover:bg-white hover:text-gray-900 text-lg px-8 py-6 transition-all duration-300"
            >
              Get Free Estimate
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
